import React from 'react';
import { Helmet } from 'react-helmet';

export interface IMetaProps {
    description?: string;
    keywords?: string;
    noIndex?: boolean;
    noFollow?: boolean;
}

export const Meta: React.FunctionComponent<IMetaProps> = props => {
    const robots = [
        props.noIndex && 'noindex',
        props.noFollow && 'nofollow',
    ].filter(Boolean).join(', ');

    return (
        <Helmet>
            {!!props.description && <meta id="description" name="description" content={props.description}/>}
            {(props.keywords?.length ?? 0) > 0 && (
                <meta id="keywords" name="keywords" content={props.keywords}/>
            )}
            {!!robots && <meta id="robots" name="robots" content={robots}/>}
        </Helmet>
    );
};
